import Vue from 'vue';
import './layout.scss';
import mhek from '../../modules/MHEK/mhek';
import layoutBase from '../layout-base.js';
new Vue({ extends: layoutBase, components: { mhek } }).$mount('[data-layout-id="AHEL-app"]');
